<div class="feature-card">
  <mat-card class="card basic-tab" *ngIf="basicFeatures$ | async as basicFeatures">
    <mat-card-content>
      <form class="form">
        <div class="form-group municipality-permission">
          <div class="header-container">
            <label class="label">{{ 'module.userProfile.generalInformation.functionalityOnOffText' | translate }}</label>
            <label class="right-label">{{ 'module.userProfile.generalConfiguration.activePremiumTabLabel' | translate }}</label>
          </div>
          <div class="page-permissions">
            <div *ngFor="let basicFeature of basicFeatures; trackBy: trackByFn">
              <div *ngIf="!basicFeature.parentPermissionID" class="checkbox-row">
                <label class="checkbox-label ep-text-regular-16" [ngClass]="!basicFeature.isActive ? 'not-active-feature' : ''">{{ basicFeature.name }}</label>
                <mat-checkbox
                  *ngIf="!basicFeature.childPermissions.length"
                  class="checkbox"
                  [disabled]="!(isMunicipalityActive$ | async) || !basicFeature.isActive"
                  [checked]="!basicFeature.isRestricted"
                  (change)="toggleFeature($event.checked, basicFeature.guid)"
                ></mat-checkbox>
              </div>
              <div *ngFor="let child of basicFeature.childPermissions; trackBy: trackByFn" class="checkbox-row child-permission">
                <label class="checkbox-label ep-text-regular-16" [ngClass]="!child.isActive ? 'not-active-feature' : ''">
                  {{ child.name }}
                </label>
                <mat-checkbox
                  class="checkbox"
                  [disabled]="!(isMunicipalityActive$ | async) || !child.isActive || !basicFeature.isActive"
                  [checked]="!child.isRestricted"
                  (change)="toggleFeature($event.checked, child.guid)"
                >
                </mat-checkbox>
              </div>
            </div>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
